<template>
  <div class="filters container-fluid p-0">
    <div class="row flex-nowrap no-gutters">
      <div class="col">
        <text-input v-bind:text-value="column.Search" v-on:input="$emit('input', $event)" v-bind:disabled="isColumnSearchDisabled()"/>
      </div>
      <div class="col-auto" v-if="advancedFiltering">

        <drop-down ref="dropdown" :position="'dropdown-menu-right py-0'" @toggle="filterOpen = $event">
          <template v-slot:button>
           <a class="btn btn-link px-1" href="javascript:void(0)">
              <icon-base :view-box="'0 0 28 28'" :width="15" :height="15" :icon-color="colorIcon">
                <filter-icon />
              </icon-base>
            </a>
          </template>

          <transition name="fade">
            <div class="filters filter-container"  @click.stop>
              <div class="container-fluid p-0" v-if="filterOpen">
                <div class="row">
                  <div class="col">
                    <div class="card border-0">
                      <div class="card-header">
                        <h3>{{ $t('grid.filters.advanced_search') }} ({{ column.Title }})</h3>
                      </div>
                      <div class="card-body pt-0">

                        <div class="row" v-show="!isColumnSearchDisabled()">
                          <div class="col pt-3">
                            <label>{{ $t('grid.filters.search_on') }}</label>
                            <text-input :label="$t('grid.filters.contains')" v-bind:text-value="column.Search" v-on:input="$emit('input', $event)" v-bind:disabled="isColumnSearchDisabled()"/>
                          </div>
                        </div>

                        <div class="row">
                          <edit-menu :menu-items="menuItems" />
                        </div>

                        <div class="row">
                          <div class="col py-2">
                            <column-advanced-filter v-for="(item) in advancedFilters" :item="item" :key="item" :column="column" @remove="removeFilter(item)"/>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <loading-button :btn-class="'btn-outline-secondary w-100'" @click="eraseFilter" :title="$t('grid.filters.erase')"></loading-button>
                          </div>
                          <div class="col">
                            <loading-button :btn-class="'btn-primary w-100'" @click="applyFilter" :title="$t('grid.filters.apply')"></loading-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>                              
        </drop-down>
        
      </div>
    </div>
  </div>
</template>
<script>
import utils from 'libs/utils';
import TextInput from 'components/TextInput.vue';
import IconBase from '@/components/IconBase.vue';
import DropDown from '@/components/DropDown.vue';
import ColumnAdvancedFilter from './ColumnAdvancedFilter.vue';
import { EditMenuItem } from 'components/NavBar.vue';

const Filter = {
  template: `<path d="M21.922 4.609a.984.984 0 01-.219 1.094L14 13.406V25c0 .406-.25.766-.609.922A1.158 1.158 0 0113 26a.932.932 0 01-.703-.297l-4-4A.996.996 0 018 21v-7.594L.297 5.703a.984.984 0 01-.219-1.094C.234 4.25.594 4 1 4h20c.406 0 .766.25.922.609z"/>`
};

export default {
  components: {
    'text-input': TextInput,
    'icon-base': IconBase,
    'drop-down': DropDown,
    'filter-icon': Filter,
    'column-advanced-filter': ColumnAdvancedFilter
  },
  data () {
    return {
      advancedFilters: [],
      filterOpen: false,
      menuItems: [new EditMenuItem(this.$t('grid.filters.add_filter'), this.addFilter, 'editmenu-create')]
    };
  },
  props: {
    column: {
      required: true
    }
  },
  mounted () {
    if (this.column.AdvancedFilters) {
      this.loadExistingColumnFilters(this.column);
    }
  },
  methods: {
    isColumnSearchDisabled() {
      return utils.isColumnSearchDisabled(this.column);
    },
    addFilter() {
      this.advancedFilters.push({ selector: this.column.FieldName, enabled: true });
    },
    eraseFilter () {
      this.advancedFilters = [];
      this.$emit('input', '');
      this.applyFilter();
    },
    applyFilter() {
      let appliedfilters = this.advancedFilters;
      this.column.AdvancedFilters = appliedfilters;
      this.$emit('filter-change', appliedfilters);
      this.$refs.dropdown.toggleDropDown();
    },
    loadExistingColumnFilters(column) {
      this.advancedFilters = [];
      column.AdvancedFilters.forEach(x => this.advancedFilters.push({...x}));
    },
    removeFilter(item) {
      this.advancedFilters = this.advancedFilters.filter(x => x !== item);
    }
  },
  computed: {
    filtersEnabled() {
      return (this.column.Search && this.column.Search.length > 0) || (this.column.AdvancedFilters && this.column.AdvancedFilters.length > 0);
    },
    advancedFiltering() {
      if (!this.column || this.column.AdvancedFilterType === undefined) return false;
      // disabled
      return this.column.AdvancedFilterType != -1;
    },
    colorIcon() {
      if (this.filtersEnabled) {
        return '#1e88e5';
      } else {
        return '#999';
      }
    },
    hasFilters () {
      return this.advancedFilters.some(x => x.value && x.value.length > 0);
    }
  },
  watch: {
    'column.AdvancedFilters':  {
      handler: function(newvalue, oldvalue) {
        if (this.column.AdvancedFilters) {
          this.loadExistingColumnFilters(this.column);
        }
      },
      immediate: true,
      deep: true
    },
    filterOpen: {
      handler: function(newvalue, oldvalue) {
        if (newvalue === true) {
          this.loadExistingColumnFilters(this.column);
        }
      },
      immediate: false
    }
  }
};
</script>

<style lang="scss" scoped>
.filters {
  z-index: 3;
  font-weight: initial;
}
.filter-container {
  width: 400px;;
}
</style>